<template>
  <el-row :gutter="uploadType === '1' ? 10 : 0" class="batch_upload_class">
    <el-col :span="uploadType === '1' ? 10 : 24">
      <el-card style="height: 500px;overflow-y: auto;" shadow="hover">
        <el-form size="mini" label-width="100px">
          <el-form-item label="单据类型">
            <el-input v-model="uploadData.module" disabled></el-input>
          </el-form-item>
          <el-form-item label="上传类型" v-if="uploadClassify === 'HD'">
            <template slot="label">
              <span>上传类型</span>
              <el-tooltip class="item" effect="dark" content="" placement="bottom-start">
                <div slot="content" v-if="uploadType === '1' && batchUploadType === '1'">
                  批量上传对应托运单号：根据文件命名（以托运单号加后缀，比如13Y0YD2511172512-1，13Y0YD2511172512-2）根据托运单号批量上传自动识别单号匹配到对应的托运单。
                  <br/>
                  备注：如果上传单号错误或重复 不允许上传
                </div>
                <div slot="content" v-else-if="uploadType === '1' && batchUploadType === '2'">
                  批量上传对应客户单号：根据文件命名（以客户单号加后缀，比如 客户单号-1，客户单号-2）根据客户单号批量上传自动识别单号匹配到对应的托运单。
                  <br/>
                  备注：如果上传单号错误或重复 不允许上传
                </div>
                <div slot="content" v-else-if="uploadType === '2'">
                  批量上传不对应托运单号：适用于多个托运单上传同一批回单。
                </div>
                <i style="font-size: 15px;color: #7D8790;margin-left: 6px;" class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <el-select style="width: 100%" v-model="batchUploadType" :disabled="uploadType === '2'">
              <el-option label="批量上传对应托运单号" value="1" v-show="uploadType === '1'"></el-option>
              <el-option label="批量上传对应客户单号" value="2" v-show="uploadType === '1'"></el-option>
              <el-option label="批量上传不对应托运单号" value="3" v-show="uploadType === '2'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="编号" v-show="false">
            <label slot="label">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</label>
            <el-input v-model="uploadData.objectNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="文件说明">
            <el-input v-model="uploadData.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label-width="80px">
            <el-upload
                class="upload-ali-demo"
                ref="refUploadAli"
                action
                :data="uploadData"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :auto-upload="false"
                accept=".jpg,.jpeg,.png,.pdf,.gif,.xls,.xlsx,.doc,.docx,.avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4,.mp3,.wma,.flac,.ape,.wav,.aac,.m4a"
                :before-upload="beforeAvatarUpload"
                multiple
                :on-exceed="handleExceed"
                :on-change="handleChange"
                :on-success="onSuccess"
                :on-error="onError"
                list-type="picture"
                :file-list="fileList">
              <el-button slot="trigger" size="mini" type="primary" icon="el-icon-folder-opened">选择文件</el-button>
              <el-button style="margin-left: 10px;" size="mini" type="info" @click="submitUpload" :loading="loading">开始上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-col :span="uploadType === '1' ? 14 : 0">
      <el-card shadow="hover" class="batch_upload_Progress" style="height: 500px;overflow-y: auto;">
        <div class="flex flex-row justify-between mb-1">
          <span style="font-size: 14px;">条数 {{currentIndex}} / {{batchTotal}}</span>
          <el-button type="danger" size="mini" :loading="currentIndex < batchTotal" @click="exportBatchDetail">导出上传结果</el-button>
        </div>
        <el-progress :percentage="batchProgress" v-if="batchTotal > 0"></el-progress>
        <div v-if="results.length > 0" class="result">
          <div v-for="(result, index) in results" :key="index">
            <el-card shadow="hover">
              <div v-if="result.state === '成功'" class="result-item">
                <div class="state-success">
                  <i class="el-icon-success"></i><span class="iconFont">成功</span>
                </div>
                <span class="docNo">{{ result.docNo }}</span>
                <span class="content">{{ result.data }}</span>
              </div>
              <div v-else class="result-item">
                <div class="state-error">
                  <i class="el-icon-error"></i><span class="iconFont">失败</span>
                </div>
                <span class="docNo">{{ result.docNo }}</span>
                <span class="content">{{ result.data }}</span>
              </div>
            </el-card>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>

import store from '@/store/index'
import { uploadAli } from '@/api/basic/customer'
import { uploadAliLogisticBatch } from '@/api/basic/logistic'
import { checkFileName, uploadAliHdBatch, batchSaveHdWithFileName } from '@/api/tms/tmshd'
import axios from 'axios'
import dayjs from 'dayjs'
import { validatenull } from '@/tdcommon/validate'
import { uploadAliReceivableSignatureBatch } from '@/api/tms/receivable'
import { excelExportFile } from '@/tdcommon/ExcelExport'

export default {
  name: 'd2-container-uploadAli-batch',
  data () {
    return {
      loading: false,
      fileList: [],
      fileListMsg: [],
      formData: [],
      resultData: [],
      totalNumbers: 0,
      importNumbers: 0,
      filelistdata: {},
      uploadData: { module: this.customerType },
      headers: {
        'Authorization': 'Bearer ' + store.getters.access_token,
        'TENANT-ID': 1
      },
      uploadForm: [],
      srcList: [],
      fileSrcList: [],
      videoSrcList: [],
      delOssId: [],
      updateNo: '',
      updateType: '',
      uploadStatus: false,
      auditStatus: '', // 上传审核状态
      auditText: '', // 已审核的文字提示
      uploadClassify: '', // 上传分类
      batchUploadType: '', // 批量上传方式
      // 批量上传返回状态
      openProgress: false,
      batchProgress: 0,
      batchTotal: 0,
      currentIndex: 0,
      results: []
    }
  },
  props: {
    importVisible: {
      type: Boolean,
      default: () => false
    },
    uploadVisible: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    customerType: {
      type: String,
      default: () => ''
    },
    // 上传类型：1.批量上传对应托运托运单号，根据文件命名（以托运单号加后缀，比如13Y0YD2511172512-1，13Y0YD2511172512-2）根据托运单号批量上传自动识别单号匹配到对应的托运单。
    // 2.选择批量上传不对应托运单号，适用于多个托运单上传同一批回单。
    uploadType: {
      type: String,
      default: () => '2'
    }
  },
  watch: {
    customerType: function (val, oldVal) {
      this.$set(this.uploadData, 'module', val)
    }
  },
  methods: {
    // 上传
    async submitUpload (importType) {
      this.loading = true
      if (!validatenull(this.fileListMsg)) { // 判断文件是否为空
        if (this.auditStatus === '1') { // 判断上传是否已审核
          this.$message.error('上传已审核，不能更改！上传文件请先反审核！')
          this.loading = false
        } else {
          try {
            if (this.uploadType === '1') {
              this.batchTotal = this.fileListMsg.length
              this.results = []
              this.currentIndex = 0
              this.batchProgress = 0
            }
            // 创建所有保存请求的Promise数组
            const promiseArr = this.fileListMsg.map(async (file, index) => {
              try {
                if (this.uploadType === '1') { // 根据文件命名（以托运单号加后缀）上传
                  // 先校验托运单号匹配到对应的托运单
                  const checkFileName = await this.checkFileNameMsg(file.raw.name)
                  // 如果上传单号错误或重复 不允许上传 则返回错误信息
                  if (checkFileName.code !== 0) {
                    return this.batchResponse(checkFileName, file.raw.name)
                  }
                }
                // 第一步：获取阿里云上传Sign
                const uploadSign = await this.getUploadAliSign()

                // 第二步：使用获取到的Sign上传文件
                var data = uploadSign.data
                var ossData = new FormData()
                let fileNamePoint = file.raw.name.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
                let fileNameLength = file.raw.name.length // 取到文件名长度
                let imgType = file.raw.name.substring(fileNamePoint + 1, fileNameLength).toLocaleLowerCase() // 截  所有后缀格式转小写
                var fileName = ''
                if (this.uploadType === '1') {
                  fileName = file.raw.name // 原有文件名
                } else {
                  fileName = dayjs(new Date()).format('YYYYMMDDHHmmss') + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=日期+3位随机码+原有文件名
                }
                // key就代表文件层级和阿里云上的文件名
                let keyValue = data.dir + fileName
                ossData.append('name', fileName)
                ossData.append('key', keyValue)
                ossData.append('policy', data.policy)
                ossData.append('OSSAccessKeyId', data.accessid)
                ossData.append('success_action_status', 200)
                ossData.append('signature', data.signature)
                ossData.append('callback', data.callback)
                ossData.append('file', file.raw, file.raw.name)
                const uploadResult = await this.uploadAliMsg(data, ossData)

                if (uploadResult.status === 200) {
                  let fileType = ''
                  if (imgType === 'jpg' || imgType === 'jpeg' || imgType === 'png' || imgType === 'gif') { // .jpg,.jpeg,.png,.gif
                    fileType = 'picture'
                  } else if (imgType === 'xls' || imgType === 'xlsx' || imgType === 'doc' || imgType === 'docx' || imgType === 'pdf') { // xls,.xlsx,.doc,.docx,.pdf
                    fileType = 'file'
                  } else if (imgType === 'avi' || imgType === 'wmv' || imgType === 'mpeg' || imgType === 'mov' || imgType === 'rm' || imgType === 'rmvb' || imgType === 'flv' || imgType === 'mkv' || imgType === 'mp4') { // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
                    fileType = 'video'
                  } else if (imgType === 'mp3' || imgType === 'wma' || imgType === 'flac' || imgType === 'ape' || imgType === 'wav' || imgType === 'aac' || imgType === 'm4a') { // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
                    fileType = 'music'
                  }
                  // 第三步：使用获取到的URL保存到后台
                  const saveResult = await this.saveUploadAli(keyValue, fileName, fileType)
                  if (this.uploadType === '1') {
                    await this.batchResponse(saveResult, file.raw.name)
                  }
                  return saveResult
                }
              } catch (err) {
                console.log('err', `上传保存文件 ${file.raw.name} 失败: ${err}`)
              } finally {
                if (this.uploadType === '1') {
                  if (this.currentIndex < this.batchTotal) {
                    this.currentIndex += 1
                    this.batchProgress = Math.floor((this.currentIndex / this.batchTotal) * 100)
                  }
                }
              }
            })
            console.log('promiseArr', promiseArr)
            // 等待所有保存请求完成
            await Promise.all(promiseArr)
            this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
            this.fileListMsg = [] // 清空handlechange的文件缓存
            if (this.updateType === 'uploadBatch') {
              this.$emit('refreshClick') // 调父组件刷新表格时间
            }
            this.$message.success('所有上传完成！')
          } catch (error) {
            console.log('上传失败error', error)
          } finally {
            console.error('上传finally')
            this.loading = false
          }
        }
      } else {
        this.$message.error('请选择上传文件！')
        this.loading = false
      }
    },
    checkFileNameMsg (fileName) {
      return checkFileName(fileName, this.batchUploadType)
    },
    // 获取上传Sign
    getUploadAliSign () {
      return uploadAli()
    },
    // 上传文件
    uploadAliMsg (data, ossData) {
      console.log('上传文件')
      return axios.post(data.host, ossData, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
    saveUploadAli (keyValue, fileName, fileType) {
      if (this.updateType === 'uploadBatch' && this.uploadType === '1') { // 批量上传回单 不勾选单据，则为选择批量上传对应托运单号： 根据文件命名的托运单号批量上传自动识别单号匹配到对应的托运单。
        return batchSaveHdWithFileName(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc, // 文件说明
          batchUploadType: this.batchUploadType // 批量上传方式
        }))
      } else if (this.updateType === 'uploadBatch' && this.uploadType === '2') { // 批量上传回单 勾选单据，则为选择批量上传不对应托运单号，适用于多个托运单上传同一批回单
        return uploadAliHdBatch(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'carrier') { // 批量上传 承运单位的合同和培训资料
        return uploadAliLogisticBatch(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'receivableSignature') { // 批量上传 应收账单签收单
        return uploadAliReceivableSignatureBatch(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      }
    },
    batchResponse (res, fileName) {
      if (res.code === 0) {
        this.results.push({ state: '成功', data: res.msg, docNo: fileName })
      } else {
        this.results.push({ state: '失败', data: res.msg, docNo: fileName })
      }
    },
    // 导出批量生成收付款结果明细
    exportBatchDetail () {
      let mtableColumns = [
        { prop: 'state', label: '状态', isShowTable: '0', editOptions: [] },
        { prop: 'docNo', label: '文件名', isShowTable: '0', editOptions: [] },
        { prop: 'data', label: '返回结果', isShowTable: '0', editOptions: [] }
      ]
      let batchType = '批量上传结果'
      excelExportFile(mtableColumns, this.results, batchType)
    },
    picUpload (file) {
      uploadAli().then(response => {
        var data = response.data
        var ossData = new FormData()
        // var imgType = file.raw.name.split('.')[1]
        let fileNamePoint = file.raw.name.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
        let fileNameLength = file.raw.name.length // 取到文件名长度
        let imgType = file.raw.name.substring(fileNamePoint + 1, fileNameLength).toLocaleLowerCase() // 截  所有后缀格式转小写
        // var fileName = this.updateNo + '_' + dayjs(new Date()).format('YYYYMMDDHHmmssSSS') + Math.random().toString().substr(2, 4) + '.' + imgType // 上传阿里保存 文件名=单位编码+日期（年月日时分秒+毫秒3位数）+4位随机码+文件类型
        // var fileName = this.updateNo + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=单位编码+3位随机码+原有文件名
        var fileName = dayjs(new Date()).format('YYYYMMDDHHmmss') + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=日期+3位随机码+原有文件名
        ossData.append('name', fileName)
        // key就代表文件层级和阿里云上的文件名
        // let filename = file.file.name + file.file.size
        // let keyValue = data.dir + '/' + filename + '.' + imgType
        let keyValue = data.dir + fileName
        ossData.append('key', keyValue)
        ossData.append('policy', data.policy)
        ossData.append('OSSAccessKeyId', data.accessid)
        ossData.append('success_action_status', 200)
        ossData.append('signature', data.signature)
        ossData.append('callback', data.callback)
        ossData.append('file', file.raw, file.raw.name)
        axios.post(data.host, ossData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          let fileType = ''
          if (imgType === 'jpg' || imgType === 'jpeg' || imgType === 'png' || imgType === 'gif') { // .jpg,.jpeg,.png,.gif
            fileType = 'picture'
          } else if (imgType === 'xls' || imgType === 'xlsx' || imgType === 'doc' || imgType === 'docx' || imgType === 'pdf') { // xls,.xlsx,.doc,.docx,.pdf
            fileType = 'file'
          } else if (imgType === 'avi' || imgType === 'wmv' || imgType === 'mpeg' || imgType === 'mov' || imgType === 'rm' || imgType === 'rmvb' || imgType === 'flv' || imgType === 'mkv' || imgType === 'mp4') { // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
            fileType = 'video'
          } else if (imgType === 'mp3' || imgType === 'wma' || imgType === 'flac' || imgType === 'ape' || imgType === 'wav' || imgType === 'aac' || imgType === 'm4a') { // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
            fileType = 'music'
          }
          if (res.status === 200) {
            if (this.updateType === 'uploadBatch') { // 批量上传回单
              uploadAliHdBatch(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              }).catch(() => {
                this.loading = false
              })
            } else if (this.updateType === 'carrier') { // 批量上传 承运单位的合同和资质
              uploadAliLogisticBatch(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              }).catch(() => {
                this.loading = false
              })
            } else if (this.updateType === 'receivableSignature') { // 批量上传 应收账单签收单
              uploadAliReceivableSignatureBatch(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              }).catch(() => {
                this.loading = false
              })
            }
          }
        }).catch(() => {
        })
      })
    },
    handleChange (file, fileList) {
      this.fileListMsg = fileList
    },
    handleRemove (file, fileList) {
    },
    handlePreview (file, fileList) {
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 判断导入的格式是不是xls、xlsx、...，如果不是则提示
    beforeAvatarUpload (file, fileList) {
      const isIMAGE = file.type === '.jpg' || '.jpeg' || '.png' || '.gif' // .jpg,.jpeg,.png,.gif
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isFile = testmsg === '.xls' || '.xlsx' || '.doc' || '.docx' || '.pdf'
      const isVideo = testmsg === '.avi' || '.wmv' || '.mpeg' || '.mov' || '.rm' || '.rmvb' || '.flv' || '.mkv' || '.mp4' // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
      const isMusic = testmsg === '.mp3' || '.wma' || '.flac' || '.ape' || '.wav' || '.aac' || '.m4a' // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
      const isLt2M = file.size / 1024 / 1024 < 50

      if (!isFile || !isVideo || !isMusic || !isIMAGE) {
        this.$message.error('上传文件格式不支持！')
        return false
      }
      // if (!isIMAGE) {
      //   this.$message.error('上传文件只能是图片格式!')
      // }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 50MB!')
      }
      return (isIMAGE || isFile || isVideo || isMusic) && isLt2M
      // return isIMAGE
    },
    // 上传成功
    onSuccess (res, file, fileList) {
      // let val = ''
      // fileList.forEach(item => {
      //   if (val !== '') {
      //     val += ','
      //   }
      //   if (item.response) {
      //     val += item.response.data.downloadPath
      //   } else {
      //     val += item.url
      //   }
      // })
      // this.$emit('input', val)
      // this.uploadAliyun(res, file)
    },
    // 上传失败
    onError () {
    },
    // 获取客户编号
    getupdateNo (cusNo, type, classify, auditStatus, auditText) {
      // this.results = [
      //   { state: '成功', data: '', docNo: '13Y02025120510001-1' },
      //   { state: '失败', data: '单据不存在', docNo: '13Y02025120510001-2' },
      //   { state: '成功', data: '上传成功', docNo: '13Y02025120510001-3' },
      //   { state: '成功', data: '', docNo: '13Y02025120510001-1' },
      //   { state: '失败', data: '单据不存在', docNo: '13Y02025120510001-2' },
      //   { state: '成功', data: '上传成功', docNo: '13Y02025120510001-3' },
      //   { state: '成功', data: '', docNo: '13Y02025120510001-1' },
      //   { state: '失败', data: '单据不存在', docNo: '13Y02025120510001-2' },
      //   { state: '成功', data: '上传成功', docNo: '13Y02025120510001-3' },
      //   { state: '成功', data: '', docNo: '13Y02025120510001-1' },
      //   { state: '失败', data: '单据不存在', docNo: '13Y02025120510001-2' },
      //   { state: '成功', data: '上传成功', docNo: '13Y02025120510001-3' },
      //   { state: '成功', data: '', docNo: '13Y02025120510001-1' },
      //   { state: '失败', data: '单据不存在', docNo: '13Y02025120510001-2' },
      //   { state: '成功', data: '上传成功', docNo: '13Y02025120510001-3' },
      //   { state: '成功', data: '', docNo: '13Y02025120510001-1' },
      //   { state: '失败', data: '单据不存在', docNo: '13Y02025120510001-2' },
      //   { state: '成功', data: '上传成功', docNo: '13Y02025120510001-3' },
      //   { state: '成功', data: '', docNo: '13Y02025120510001-1' },
      //   { state: '失败', data: '单据不存在', docNo: '13Y02025120510001-2' },
      //   { state: '成功', data: '上传成功', docNo: '13Y02025120510001-3' },
      // ]
      this.updateNo = cusNo
      this.updateType = type
      this.uploadClassify = classify // 上传分类
      this.auditStatus = auditStatus // 上传审核状态（'1'为已审核，'0'为未审核）
      this.auditText = auditText // 已审核的文字提示
      this.batchUploadType = this.uploadType === '2' ? '3' : this.uploadType // 批量上传方式
      this.$set(this.uploadData, 'objectNo', cusNo)
    },
    // 关闭时清空srclist
    clearSrcList () {
      this.srcList = []
      this.fileSrcList = []
      this.videoSrcList = []
      this.$set(this.uploadData, 'objectNo', '') // 清空编号
      this.$set(this.uploadData, 'fileDesc', '') // 清空文件说明
      this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
    },
    listString (imageList) {
      var imageArray = []
      imageList.forEach(item => {
        imageArray.push(item.url)
      })
      return imageArray
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.batch_upload_class {
  .batch_upload_Progress {
    .result {
      border-top: 1px solid #DCDFE6;
      border-bottom: 1px solid #DCDFE6;
      height: 400px;
      margin-top: 5px;
      overflow-y: auto;
      .result-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        .state-success, .state-error {
          color: #67C23A;
          font-size: 16px;
          min-width: 52px;
          .iconFont {
            margin-left: 5px;
            font-size: 15px;
            font-weight: bold;
          }
        }
        .state-error {
          color: #F56C6C;
        }
        .docNo {
          margin-left: 30px;
          color: #409EFF;
          min-width: 135px;
        }
        .content {
          margin-left: 30px;
        }
      }
    }
    .el-card {
      margin: 4px 0;
      .el-card__body {
        padding: 10px 20px;
      }
    }
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-uploadAli-batch/index.vue"
}
</vue-filename-injector>
